import { render, staticRenderFns } from "./twofloor.vue?vue&type=template&id=81f92e4a&scoped=true&"
import script from "./twofloor.vue?vue&type=script&lang=js&"
export * from "./twofloor.vue?vue&type=script&lang=js&"
import style0 from "./twofloor.vue?vue&type=style&index=0&id=81f92e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f92e4a",
  null
  
)

export default component.exports